'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import type { TripCardRecord } from '~/libs/dato/fragments/components/nUpTripContainerSectionFragment';
import type { BlueprintTagged } from '~/libs/dato/queries/blueprints';
import type { TransformedVirtualBlueprint } from '~/services/dato/blueprints.service';
import { getCookie } from '~/utils/cookies';
import { CURRENT_PROMO, isBlueprintPromoEligible } from '~/utils/promoHelper';
import { BlueprintCard } from './BlueprintCard';
import { StaticCard } from './StaticCard';
import type { TripCardProps } from './TripCard.types';
import { VirtualBlueprintCard } from './VirtualBlueprintCard';
const TripCard = t0 => {
  const $ = _c(13);
  const {
    trip
  } = t0;
  const [isUkCustomer, setIsUkCustomer] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = CURRENT_PROMO();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    isPromoLive
  } = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsUkCustomer(getCookie("displayCountry") === "GB");
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  switch (trip._modelApiKey) {
    case "blueprint":
      {
        const blueprintTrip = trip as BlueprintTagged;
        let t4;
        if ($[3] !== blueprintTrip || $[4] !== isUkCustomer) {
          t4 = isUkCustomer && isPromoLive && isBlueprintPromoEligible(blueprintTrip.eligiblePromotions);
          $[3] = blueprintTrip;
          $[4] = isUkCustomer;
          $[5] = t4;
        } else {
          t4 = $[5];
        }
        const showPromoBadge = t4;
        let t5;
        if ($[6] !== blueprintTrip || $[7] !== showPromoBadge) {
          t5 = <BlueprintCard trip={blueprintTrip} showPromoBadge={showPromoBadge} />;
          $[6] = blueprintTrip;
          $[7] = showPromoBadge;
          $[8] = t5;
        } else {
          t5 = $[8];
        }
        return t5;
      }
    case "landing_page_virtual_blueprint":
      {
        const t4 = trip as TransformedVirtualBlueprint;
        let t5;
        if ($[9] !== t4) {
          t5 = <VirtualBlueprintCard trip={t4} />;
          $[9] = t4;
          $[10] = t5;
        } else {
          t5 = $[10];
        }
        return t5;
      }
    default:
      {
        const t4 = trip as TripCardRecord;
        let t5;
        if ($[11] !== t4) {
          t5 = <StaticCard trip={t4} />;
          $[11] = t4;
          $[12] = t5;
        } else {
          t5 = $[12];
        }
        return t5;
      }
  }
};
export { TripCard };